export const TALKS_PLAYLIST_URL =
  "https://www.youtube.com/playlist?list=PLvMEdv7wBhWkVGHOacHvvqkqV_Z_4Oxkf"

export const RESUME_URL =
  "https://drive.google.com/drive/folders/1EJj38ejYCwwtAvFxKIazU5TEOk3MzBco"
